import { useMediaQuery } from '@mui/material';

/**
 * Returns true when the user prefers reduced motion.
 * Every animated component should import this and conditionally disable animations.
 */
export const useReducedMotion = (): boolean =>
  useMediaQuery('(prefers-reduced-motion: reduce)');
